/**
 * One-time purchase CTA handler.
 *
 * Adds the current product variant to cart as a ONE-TIME purchase (posts
 * id + quantity only, no selling_plan) regardless of the Recharge widget
 * selection, then refreshes the mini-cart using the theme's existing globals.
 *
 * Shares the in-flight guard, Adding…/Added ✓ button feedback and failure
 * reconciliation with the main PDP and sticky buttons via window.iwAtc
 * (assets/iw-atc-feedback.js, loaded in scripts_head).
 *
 * Wired via a delegated click listener on `.js-one-time-atc` (bottom of file).
 * Defined on window once; loading this asset more than once is harmless.
 */
window.addOneTimeToCart = window.addOneTimeToCart || function (btn) {
  var select = document.getElementById('product-select');
  var variantId = (select && select.value) || (btn && btn.getAttribute('data-variant-id'));
  if (!variantId) return;

  // A readOnly selector is one pdp-price-sync has locked to a Recharge tier's
  // unit count. That count belongs to the subscription, not to this one-time
  // add, so it starts from a single unit rather than inheriting the tier's.
  var qtyEl = document.querySelector('.js-quantity-selector');
  var qty = qtyEl && qtyEl.readOnly ? 1 : parseInt(qtyEl && qtyEl.value, 10);
  if (!qty || qty < 1) qty = 1;

  window.iwAtc.guardedAdd(btn, function () {
    return window.iwAtc.add({ id: variantId, quantity: qty }, qty);
  }, { variantId: variantId, sellingPlan: '' });
};

if (!window.iwOneTimeBound) {
  window.iwOneTimeBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-one-time-atc');
    if (!btn) return;
    e.preventDefault();
    window.addOneTimeToCart(btn);
  });
}
